import Modal from "../../Modal";

interface ListingAlertProps {
  visible: boolean;
  handleModalClose: () => void;
}

export const ListingAlert: React.FC<ListingAlertProps> = ({
  visible,
  handleModalClose,
}) => {
  return (
    <Modal
      className={"w-96 model p-4 "}
      visible={visible}
      onClose={handleModalClose}
    >
      <div className="w-full pb-6">
        <p className="text-lg">Create A New Construction Listing Alert</p>
      </div>
      <form className="pb-2" onSubmit={() => {}}>
        <div className="flex flex-wrap gap-4 flex-col">
          <div className="flex gap-4 ">
            <div className="flex-1">
              <input
                placeholder="Name"
                className="w-full outline-none border border-gray-300 py-2 px-2"
              />
            </div>
          </div>
          <select
            className="outline-none w-full border border-gray-400 p-2"
            name="notification"
            id="notification"
          >
            <option value="never">Never</option>
            <option value="daily">Daily</option>
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
          </select>
        </div>
        <div className="py-4">
          <button className="w-full bg-primary text-white py-2">Submit</button>
        </div>
      </form>
    </Modal>
  );
};
export default ListingAlert;
